<template>
    <div class="Page">
        <Header Act="99" ref="Header"></Header>
        <div class="MaxWid">
            <!-- <div class="MarTop">
                <Banner></Banner>
            </div> -->
            <div class="MarTop">
                <div class="AboutPos">当前位置：个人中心</div>
                <div class="AboutDis">
                    <div class="AboutNav">
                        <div class="AboutNavItem" :class="{Act:i==1}" @click="TogglePage(1)"><i class="iconfont icon-guanliyuan_jiaoseguanli"></i>个人信息</div>
                        <div class="AboutNavItem" v-if="isExpert" :class="{Act:i==2}" @click="TogglePage(2)"><i class="iconfont icon-pta-dashboard"></i>我的审核</div>
                        <div class="AboutNavItem" :class="{Act:i==3}" @click="TogglePage(3)"><i class="iconfont icon-wodedingdan"></i>我的作品</div>
                        <div class="AboutNavItem" :class="{Act:i==4}" @click="TogglePage(4)"><i class="iconfont icon-yonghuguanli"></i>我的劳务</div>
                        <div class="AboutNavItem" :class="{Act:i==5}" @click="TogglePage(5)"><i class="iconfont icon-jianyi"></i>草稿箱</div>
                        <div class="AboutNavItem" @click="UserOut"><i class="iconfont  icon-guanbi1"></i>安全退出</div>
                    </div>
                    <div class="AboutCont">
                        <Info v-if="i==1" @UpData="UpHead"></Info>
                        <Professional v-if="i==2" :TypeData="Data.is_register_professional"></Professional>
                        <Order v-if="i==3"></Order>
                        <Agencies v-if="i==4" :TypeData="Data.is_register_major_company "></Agencies>
                        <Caogao v-if="i==5"></Caogao>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '../../components/header/head.vue';
    import Footer from '../../components/header/footer.vue';
    import Banner from '../../components/banner/Banner.vue';
    import Info from '../../components/user/Info.vue';
    import Professional from '../../components/user/Professional.vue';
    import Order from '../../components/user/Order.vue';
    import Agencies from '../../components/user/Agencies.vue';
    import Caogao from '../../components/user/Caogao.vue';

    export default {
        components: {Header, Footer, Banner, Info, Agencies, Order, Professional, Caogao},
        data() {
            return {
                i:1,
                Data: "",
                UpDatas:false,
                isExpert: false,
            }
        },
        mounted() {
            this.getUserInfo();
        },
        methods: {
            getUserInfo() {
                this.$get('/getInfo').then(res => {
                    if (res.data.code === 200) {
                        const { roles } = res.data;
                        this.isExpert = roles && roles.includes('expert');
                        
                        if (this.$route && this.$route.query.id) {
                            if (!this.isExpert && this.$route.query.id == 2) {
                                this.i = 1;
                            } else {
                                this.i = this.$route.query.id;
                            }
                        }
                        
                        // this.GetData();
                    } else {
                        this.$message.error(res.data.msg || '登录失效，请重新登录');
                    }
                }).catch(err => {
                    console.error('登录失效，请重新登录:', err);
                    this.$message.error('登录失效，请重新登录');
                });
            },
            TogglePage(i){
                this.i = i;
            },
            UserOut() {
                this.$confirm('确认是否退出', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$post('/logout').then((res) => {
                        if (res.data.code === 200) {
                            // 清除本地存储的token和用户信息
                            localStorage.removeItem("token");
                            localStorage.removeItem("userInfo");
                            
                            // 触发头部组件更新
                            this.$bus.$emit('updateUser');
                            
                            this.$message({ message: '退出成功', type: 'success' });
                            this.$router.push('/');
                        } else {
                            this.$message({ message: res.data.msg || '退出失败', type: 'error' });
                        }
                    }).catch(() => {
                        // 即使请求失败也清除本地信息并跳转
                        localStorage.removeItem("token");
                        localStorage.removeItem("userInfo");
                        this.$bus.$emit('updateUser');
                        this.$router.push('/');
                    });
                }).catch(() => {
                    // 用户点击取消
                    this.$message({
                        type: 'info',
                        message: '已取消退出'
                    });
                });
            },
            UpHead(){
                this.$refs.Header.UpData();
            },
            //跳转
            GoPage(url) {
                this.$router.push({
                    path: url
                });
            },
        },
    }
</script>
<style scoped>
    .Page {
        background: #fff;
    }

    .BgColorBlue {
        background-color: #037dbe;
    }

    .BgColorYellow {
        background-color: #ed8404;
    }

    .BgColorGreen {
        background-color: #82ae1d;
    }

    .MarTop {
        margin-top: 20px;
    }
    .MaxWid {
        max-width: 1180px;
        padding: 0 10px;
        margin: 0 auto;
    }
    .AboutPos{
        padding: 20px 0;
        font-size: 12px;
        color: #999999;
    }
    .AboutDis{
        display: flex;
        margin-bottom: 30px;
    }
    .AboutNav{
        width: 250px;
        background: #58C1B6;
        flex-shrink: 0;
    }
    .AboutNavItem{
        padding: 15px;
        font-size: 16px;
        color: #fff;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: left;
    }
    .AboutNavItem:hover,
    .AboutNavItem.Act{
        background: #fff;
        color: #58C1B6;
    }
    .AboutNavItem .iconfont{
        font-size: 22px;
        margin-right: 10px;
    }
    .AboutCont{
        flex: 1;
        margin-left: 20px;
        overflow-x: auto;
        min-width: 0;
    }
    @media only screen and (max-width: 768px){
        .AboutDis{
            display: block;
            margin-bottom: 20px;
        }
        .AboutNav{
            margin-bottom: 15px;
            width: 100%;
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 10px;
            background: transparent;
        }
        .AboutNavItem{
            padding: 10px 5px;
            font-size: 14px;
            text-align: center;
            background: #58C1B6;
            border-radius: 4px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .AboutNavItem .iconfont{
            display: none;
        }
        .AboutNavItem:hover,
        .AboutNavItem.Act{
            background: #fff;
            color: #58C1B6;
            border: 1px solid #58C1B6;
        }
        .AboutCont{
            margin: 0;
            width: 100%;
            overflow-x: auto;
        }
        .MaxWid {
            padding: 0 5px;
        }
        .AboutPos {
            padding: 10px 0;
        }
    }
</style>